'use strict';

angular.module('webmailWrapper')
    .controller('TopMenuCtrl', function($scope, mailbox, entryPointProvider) {
        $scope.mailbox = mailbox;
        $scope.entryPoint = entryPointProvider.entryPoint;
    });
